module.exports = __webpack_public_path__ + "202408221624/img/home_shop_1.7cd046c0.png";